import * as stylex from "@stylexjs/stylex";
import { ArrowUpRight } from "lucide-react";
import { copy } from "@/copy";
import "@/theme/tokens.stylex";
import { colors, radii, sizes, space } from "@/theme/tokens.stylex";
import { Icon } from "@/ui/Icon";
export function GuideTermsCard() {
  const text = copy.settings.links;
  return <nav aria-label={text.label} className="x78zum5 xdt5ytf xeuugli xh540kj xwe7p7i x1tn7zi3 x1quw8nh x9f619">
      <a href="/guide" target="_blank" rel="noopener" className="x78zum5 x6s0dn4 x1qughib xddi9bj x1yjznld x1a11ngh xkrqix3">
        <span className="x19d36u7 xfbjfs5 x1j7pf75">{text.guide}</span>
        <Icon icon={ArrowUpRight} size={20} />
      </a>
      <a href="/terms" target="_blank" rel="noopener" className="x78zum5 x6s0dn4 x1qughib xddi9bj x1yjznld x1a11ngh xkrqix3 x1jidhvw">
        <span className="x19d36u7 xfbjfs5 x1j7pf75">{text.terms}</span>
        <Icon icon={ArrowUpRight} size={20} />
      </a>
    </nav>;
}